import { styled } from '@gogovan/entier-web-core/ext/mui/styles';

const TrackingRecordRow = styled('div')`
  font-size: 14px;
  display: grid;
  grid-auto-columns: auto;
  grid-template-columns: 1fr 1.5fr 1fr;
  margin-top: 15px;
  color: unset;

  ${(props) => props.theme.breakpoints.down('sm')} {
    display: block;
    line-height: 20px;
    margin-top: ${(props) => (props.noHeader ? 5 : 15)}px;
  }
`;

const BoldedText = styled('div')`
  font-weight: 500;
  color: unset;
`;

const NormalText = styled('div')`
  opacity: 60%;
  color: unset;
`;

const DateTimeText = styled('div')`
  opacity: 60%;
  display: flex;
  justify-content: end;
  color: unset;

  ${(props) => props.theme.breakpoints.down('sm')} {
    justify-content: unset;
  }
`;

const TimeWrapper = styled('div')`
  margin-left: 20px;

  ${(props) => props.theme.breakpoints.down('sm')} {
    margin-left: 10px;
  }
`;

export { TrackingRecordRow, BoldedText, NormalText, DateTimeText, TimeWrapper };
